/**
 * Component: Quick view
 * ------------------------------------------------------------------------------
 * A quick view file that contains scripts to function.
 *
 * @namespace quickView
 */
import log from 'salvo-lite/log'

import axios from 'axios'

import loaders from '../helpers/loaders'
import {on} from '../helpers/utils'
import cssClasses from '../helpers/cssClasses'

class QuickView {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            body: '[js-quick-view="body"]',
            viewport: '[js-quick-view="viewport"]',
            ...JSON.parse(elem.getAttribute('data-quick-view') || '{}')
        }

        log.debug(this.constructor.name, 'Constructed', this)

        /**
         * Attribute and data selectors.
         */
        this._dataSelectors = {
            quickView: 'js-quick-view'
        }

        /**
         * DOM node selectors.
        */
        this._nodeSelectors = {
            body: document.querySelector(this._settings.body),
            viewport: document.querySelector(this._settings.viewport)
        }

        /**
         * Modal
        */
        this._modal = this._theme.getComponentsById('quick-view')
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._setEventListeners()
        this._setEventBusListeners()
    }

    /**
     * Set trigger listeners.
     */
    _setEventListeners () {
        on('click', this._elem, (event) => this._handleQuickViewClick(event))
    }

    /**
     * Set EventBus listeners on component.
     */
    _setEventBusListeners () {
        window.Frame.EventBus.listen('QuickView:open', (response) => this._handleQuickViewEvent(response))
    }

    /**
     * Handle quick view toggle click event.
     * @param {Event} event - Click event.
     */
    _handleQuickViewClick (event) {
        if (!this._isTargetToggle(event.target)) {
            return
        }
        event.preventDefault()
        const productHandle = event.target.dataset.productUrl.replace('/products/', '')

        window.Frame.EventBus.emit('QuickView:open', productHandle)
    }

    /**
     * Handle quick view eventbus event.
     * @param {String} handle – The product handle to quick view.
     */
    _handleQuickViewEvent (handle) {
        this._setLoadingState()
        this._toggleQuickView(handle)
    }

    /**
     * Detect quick view toggle click.
     * @param {HTMLElement} target - Clicked target to check quick view attributes against.
     */
    _isTargetToggle (target) {
        return (
            typeof target.attributes[this._dataSelectors.quickView] !== 'undefined' &&
        target.attributes[this._dataSelectors.quickView].nodeValue === 'toggle'
        )
    }

    /**
     * Toggle quick view modal after fetching data from toggle target.
     * @param {String} handle – The product handle to quick view.
     */
    _toggleQuickView (handle) {
        this._modal._show('quick-add')

        axios.get(this._getProductUrl(handle))
            .then((response) => {
                this._nodeSelectors.body.innerHTML = response.data
                this._removeLoadingState()
                return response
            })
            .catch((error) => error)
    }

    /**
     * Set loading state.
     */
    _setLoadingState () {
        this._nodeSelectors.viewport.classList.add(cssClasses.loading)
        this._nodeSelectors.body.innerHTML = loaders.ring
    }

    /**
     * Remove loading state.
     */
    _removeLoadingState () {
        this._nodeSelectors.viewport.classList.remove(cssClasses.loading)
    }

    /**
     * Get quick view product template url.
     * @param {String} handle – The product handle to quick view.
     */
    _getProductUrl (handle) {
        return `/products/${handle}?view=bc-quickview`
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // })
}

export default QuickView



// WEBPACK FOOTER //
// ./src/resources/scripts/components/QuickView.js